import { render, staticRenderFns } from "./Diagnostics.vue?vue&type=template&id=2ff6c76e&scoped=true&"
import script from "./Diagnostics.vue?vue&type=script&lang=ts&"
export * from "./Diagnostics.vue?vue&type=script&lang=ts&"
import style0 from "./Diagnostics.vue?vue&type=style&index=0&id=2ff6c76e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6c76e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VToolbar,VToolbarTitle})
